const sharedProperty = {
	configurable: true,
	enumerable: true,
	get: undefined,
	set: undefined
}

export function proxy(target, sourceKey, key) {
	sharedProperty.get = function proxyGetter() {
		return target[sourceKey][key];
	}
	sharedProperty.set = function proxySetter(val) {
		target[sourceKey][key] = val;
	}
	Object.defineProperty(target, key, sharedProperty);
}
